import { render, staticRenderFns } from "./auction-card.vue?vue&type=template&id=bc9d0c90&scoped=true&"
import script from "./auction-card.vue?vue&type=script&lang=js&"
export * from "./auction-card.vue?vue&type=script&lang=js&"
import style0 from "./auction-card.vue?vue&type=style&index=0&id=bc9d0c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9d0c90",
  null
  
)

/* custom blocks */
import block0 from "./auction-card.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports